// extracted by mini-css-extract-plugin
export var category = "_kk-9";
export var categoryHeader = "_kk-e";
export var container = "_kk-0";
export var group = "_kk-a";
export var groupItems = "_kk-f";
export var groupSeparator = "_kk-j";
export var loading = "_kk-1";
export var noResults = "_kk-3";
export var placeholder = "_kk-2";
export var resultContent = "_kk-5";
export var resultIcon = "_kk-c";
export var resultItem = "_kk-g";
export var resultMeta = "_kk-8";
export var resultSubtitle = "_kk-7";
export var resultSuffix = "_kk-i";
export var resultTitle = "_kk-6";
export var resultsList = "_kk-4";
export var searchGroup = "_kk-d";
export var selected = "_kk-h";
export var subgroup = "_kk-b";